import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css'
})
export class IconComponent implements OnChanges {
  @Input() aberto = false;
  
  ngOnChanges(changes: SimpleChanges): void {
    this.toggleClassIcon()
  }
  public toggleClassIcon(): void {
    const icone = document.getElementById('icone')!;

    icone.className = this.aberto ? 'filterIcon-open icon-container' : 'filterIcon-close icon-container';
    document.getElementById('bar1')!.className = this.aberto ? 'bar bar1-open' : 'bar bar1-close';
    document.getElementById('bar2')!.className = this.aberto ? 'bar bar2-open' : 'bar bar2-close';
    document.querySelectorAll('.circle').forEach(c => {
      c.className = this.aberto ? 'circle circle-open': 'circle circle-close';
    });
  }
}
